import { Instance, types } from 'mobx-state-tree';
import { ReferrerReviewStore } from '../order-review/sponsor-enroller-review/ReferrerReviewStore';
import { EnrollmentOrderInfoStore } from './EnrollmentOrderInfoStore';
import { EnrollmentRootStore } from '../root/EnrollmentRootStore';
import { getRootStore } from '../root/RootStoreUtils';

export const SocialLinkEntryStore = types
  .model('SocialLinkEntryStore', {
    enrollmentOrderInfo: types.maybe(EnrollmentOrderInfoStore),
    referrerReview: types.maybe(ReferrerReviewStore),
    isMeoMarket: types.boolean,
    minimumEnrollmentOrderPv: types.number,
    minimumErPv: types.optional(types.number, 0),
    consentedToPlacement: types.optional(types.boolean, true),
    showMinimumPvWarning: types.optional(types.boolean, false),
    showErAgreementModel: types.optional(types.boolean, false),
    erAgreementAccepted: types.optional(types.boolean, false),
    isEnableForErAgreement: types.optional(types.boolean, false),
    isErAgreementDismissible: types.optional(types.boolean, false),
    isErAgreementDismissed: types.optional(types.boolean, false),
    scrollText: types.optional(types.string, ''),
    text: types.optional(types.string, ''),
    allowToBypassMeoRequirementWithPSK: types.optional(types.boolean, false)
  })
  .views(self => ({
    getDataToSubmit(): any {
      return {
        erAgreementAccepted: self.isEnableForErAgreement ? self.erAgreementAccepted : null,
        isErAgreementDismissed: self.isEnableForErAgreement ? self.isErAgreementDismissed : null
      };
    },
    canProceed(): boolean {
      const enrollmentLimit = !self.allowToBypassMeoRequirementWithPSK ? this.validated && this.isMinimumEnrollmentPvReached : self.allowToBypassMeoRequirementWithPSK;
      const essentialRewardsLimit = this.isERValidated && this.isMinimumErPvReached;
      return ( self.enrollmentOrderInfo?.isEnrollingInEr ? (enrollmentLimit && essentialRewardsLimit): enrollmentLimit) ;
    },
    get validated(): boolean {
      if (!self.enrollmentOrderInfo!.starterKit && self.enrollmentOrderInfo!.additionalItems.length === 0) return false;
      return true;
    },
    get isERValidated(): boolean {
      if (!self.enrollmentOrderInfo!.erKit && self.enrollmentOrderInfo!.erAdditionalItems.length === 0) return false;
      return true;
    },
    get isMinimumErPvReached(): boolean {
      return !self.enrollmentOrderInfo!.isEnrollingInEr || self.enrollmentOrderInfo!.totalERPv;
    },
    get isMinimumEnrollmentPvReached(): boolean {
     return (self.enrollmentOrderInfo!.starterKitPv + self.enrollmentOrderInfo!.additionalItemsTotalPv) >= self.minimumEnrollmentOrderPv ;

    },
    get rootStore(): EnrollmentRootStore {
      return getRootStore(self);
    },
    get allItemsAvailable(): boolean {
      return self.enrollmentOrderInfo!.unavailableAdditionalItems.length === 0;
    }
  }))
  .actions(self => ({
    checkMinimumEnrollmentPv() {
      if (!self.isMinimumEnrollmentPvReached && !self.allowToBypassMeoRequirementWithPSK) {
        this.updateMinimumPvWarning(true);
      }
    },
    checkMinimumErPv() {
      if (!self.isMinimumErPvReached && !self.allowToBypassMeoRequirementWithPSK) {
        this.updateMinimumPvWarning(true);
      }
    },
    updateMinimumPvWarning(value: boolean) {
      self.showMinimumPvWarning = value;
    },
    updateShowErAgreementModel(value: boolean): Promise<boolean> {
      self.showErAgreementModel = value;
      return Promise.resolve(self.erAgreementAccepted);
    },
    updateErAgreementAcceptedValue(erAgreementAccepted: boolean, isErAgreementDismissed: boolean) {
      self.erAgreementAccepted = erAgreementAccepted;
      self.isErAgreementDismissed = isErAgreementDismissed;
      if (erAgreementAccepted || isErAgreementDismissed) {
        self.showErAgreementModel = false;
        const rootStore = getRootStore(self);
        rootStore.stepsManager.nextStep(); 
      }
    },
  }));

export type SocialLinkEntryStore = Instance<typeof SocialLinkEntryStore>;
